import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Link } from '@uhg-abyss/web/ui/Link';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { AppContext } from '@src/AppContext';
import { apiItems } from './all-api';
import { event } from '@uhg-abyss/web/tools/event';

const Wrapper = styled('div', {
  margin: '64px 0 0 0',
});
const AccordianLinks = styled('div', {
  display: 'grid',
});
const StyledLink = styled(Link, {});

const AccordianLink = styled('div', {
  marginLeft: '35px',
  marginBottom: '10px',
});

const Heading = styled('h3', {
  minHeight: '32px',
  color: 'rgb(0, 38, 119)',
  fontSize: '28px ! important',
  fontWeight: 600,
  lineHeight: '32px',
  marginBottom: '45px',
});

const CategoryBox = styled('div', {});

export const APIsCategory = () => {
  const { navigate } = useRouter();
  const { filters, updateFilters } = React.useContext(AppContext);
  const apiListData = apiItems;

  const onApiClicked = async (routeLink, filterTitle, linkTitle) => {
    const newFilters = filters.map((el) => {
      const checked = el.title === filterTitle;
      return {
        ...el,
        checked,
      };
    });
    await updateFilters(newFilters);
    const interactionName = 'additional api categories';
    const interactionValue = linkTitle;
    const interactionContext = 'page cta link clicks';
    event('INTERACTION_EVENT', {
      interactionName,
      interactionValue,
      interactionContext,
    });
    navigate({
      pathname: routeLink,
      state: { filter: filterTitle },
    });
  };
  return (
    <Wrapper>
      <Heading id="Category">API categories</Heading>
      <CategoryBox>
        {apiListData?.map((el, i) => {
          return (
            <Accordion
              type="multiple"
              style={{
                marginBottom: '10px',
              }}
              css={{
                '.abyss-accordion-header': {
                  fontSize: '15px',
                },
              }}
            >
              <Accordion.Item value={el.label}>
                <Accordion.Trigger
                  style={{
                    fontWeight: 'bold',
                    fontSize: '15px',
                  }}
                >
                  <Layout.Group>
                    <IconBrand
                      id={`api-${el.label}-icon`}
                      icon={el.src}
                      size={30}
                    />
                    <Accordion.Header style={{ fontSize: '15px !important' }}>
                      {el.label}
                    </Accordion.Header>
                  </Layout.Group>
                </Accordion.Trigger>
                <Accordion.Content style={{ backgroundColor: 'inherit' }}>
                  <AccordianLinks>
                    {el.subCategory.map((item) => {
                      return (
                        <AccordianLink>
                          <StyledLink
                            size="15px"
                            fontWeight="bold"
                            onClick={() => {
                              return onApiClicked(
                                item.route,
                                el.label,
                                item.title
                              );
                            }}
                          >
                            {item.title}
                          </StyledLink>
                          <div style={{ color: 'black', fontSize: '15px' }}>
                            {item.description}
                          </div>
                        </AccordianLink>
                      );
                    })}
                  </AccordianLinks>
                </Accordion.Content>
              </Accordion.Item>
            </Accordion>
          );
        })}
      </CategoryBox>
    </Wrapper>
  );
};
